import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const maintenanceDetailsTodo = createAsyncThunk('maintenanceDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `maintanance/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const maintenanceDetailsSlice = createSlice({
    name: 'maintenanceDetails',
    initialState: {
        data: '',
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(maintenanceDetailsTodo.pending, (state) => {
            state.loading = true;
            state.data = '';
        });
        builder.addCase(maintenanceDetailsTodo.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(maintenanceDetailsTodo.rejected, (state, action) => {
            state.loading = false;
            // console.log('reject', action)
        })
    }
})

export default maintenanceDetailsSlice.reducer; 